import type { QueryEntity } from '@/sections/insights/queryBuilder/entities/types';

import { adObjectEntity } from './index';

/**
 * ADEnterpriseCA entity - alias of ADObject
 * Represents Active Directory Enterprise CA objects
 */
export const adEnterpriseCAEntity: QueryEntity<unknown> = {
  ...adObjectEntity,
  primaryLabel: { actual: 'ADEnterpriseCA', display: 'AD Enterprise CA' },
  alias: 'ADObject',
};
